import * as React from 'react'
import { FC, useCallback } from 'react'
import { styles } from './hooks/useStyles'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  deleteEditFunnelReason,
  selectEditFunnelReasonById,
  setEditFunnelReason,
} from '@user/store/salesFunnel/editSlice'
import TextField from '@mui/material/TextField'
import { CancelButton, LightTooltip } from '@sales-center/components'
import { useSelector } from 'react-redux'
import { StoreData } from '@user/store/reducers/typings'
import LockIcon from '@mui/icons-material/Lock'
import Box from '@mui/material/Box'

interface Props {
  id: string
  index: number
}

export const DisqualifyReason: FC<Props> = (props) => {
  const { id, index } = props

  const dispatch = useAppDispatch()

  const reason = useSelector((state) =>
    selectEditFunnelReasonById(state as StoreData, id),
  )

  const onChangeReason = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setEditFunnelReason({ id, reason: e.target.value }))
    },
    [dispatch, id],
  )

  const onDeleteReason = useCallback(() => {
    dispatch(deleteEditFunnelReason(id))
  }, [dispatch, id])

  if (!reason) return null
  const { reason: text, isValid, recordCount, error } = reason

  return (
    <Box sx={styles.row}>
      <Box sx={styles.actionContainer}>
        {recordCount > 0 ? (
          <LightTooltip
            title={`This reason cannot be deleted, it has ${recordCount} ${
              recordCount > 1 ? 'records' : 'record'
            } associated with it.`}
          >
            <LockIcon fontSize="small" sx={styles.smallLockIcon} />
          </LightTooltip>
        ) : (
          <CancelButton
            sx={styles.smallDeleteButton}
            onClick={onDeleteReason}
          />
        )}
      </Box>
      <TextField
        sx={styles.textField}
        required
        label={`Reason ${index + 1}`}
        variant="outlined"
        size="small"
        value={text}
        onChange={onChangeReason}
        error={!isValid}
        helperText={error}
      />
    </Box>
  )
}
